import { SlideLayout, ViewMode } from '@gripp/shared-ui';
import { useState } from 'react';
import { AccountInviteForm } from './accountInviteForm';
import { AccountsComponent } from './accountsComponent';
import { AccountsFilters } from './accountsFilters';
import { InviteShareButton } from './inviteShareButton';

export const AccountInvite = () => {
  const [invitationUrl, setInvitationUrl] = useState<string | undefined>();

  const leftColumn = {
    title: 'people.menu.people',
    mainComponent: <AccountsComponent />,
    headerComponent: <AccountsFilters />,
    disableScroll: true
  };

  const rightColumn = {
    title: 'plusMenu.invite',
    mainComponent: (
      <AccountInviteForm
        onInvitationChange={(invitation) => setInvitationUrl(invitation.url)}
      />
    ),
    headerComponent: <InviteShareButton url={invitationUrl} />,
    showBackButton: true,
    disableScroll: true
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  )
};
